import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-buk-ticket-publish-confirm-dialog',
  templateUrl: './buk-ticket-publish-confirm-dialog.component.html',
  styleUrls: ['./buk-ticket-publish-confirm-dialog.component.scss'],
})
export class BukTicketPublishConfirmDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<BukTicketPublishConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { message: string }
  ) {}

  ngOnInit(): void {
    this.dialogRef.disableClose = true;
    this.dialogRef.updateSize('480px');
  }

  public preserveFormData: boolean;

  close(): void {
    this.dialogRef.close({
      preserveFormData: this.preserveFormData,
    });
  }
}
